<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="content">
        <h1>COVID-19 Ajánlások</h1>
        <Covid19SearchBar
          :searchRoute="'list-covid-19s'"
          :placeholder="'Keressen a COVID-19 ajánlások között név vagy leírás alapján'">
        </Covid19SearchBar>
      </div>

      <div v-if="(filteredCovid19s || []).length">
        <div class="content">
          <h3>Találatok</h3>
        </div>

        <div class="columns is-multiline">
          <div class="column is-3-desktop is-4-tablet is-12-mobile flex-column"
               v-for="filteredCovid19 in filteredCovid19s"
               :key="filteredCovid19.sys.id">
            <Covid19SummaryCard
              :covid19="filteredCovid19"
              :marked="true">
            </Covid19SummaryCard>
          </div>
        </div>

        <div class="content">
          <h3>Összes COVID-19 ajánlás</h3>
        </div>
      </div>

      <div class="columns is-multiline">
        <div class="column is-3-desktop is-4-tablet is-12-mobile flex-column"
             v-for="covid19 in covid19s"
             :key="covid19.sys.id">
          <Covid19SummaryCard
            :covid19="covid19"
            :marked="false">
          </Covid19SummaryCard>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'

  /* Components */
  import Covid19SearchBar from '@/components/General/SearchBar'
  import Covid19SummaryCard from '@/components/BestPractice/Covid19SummaryCard'
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        covid19s: [],
        filteredCovid19s: [],
        isLoading: true
      }
    },
    async mounted () {
      /* Get trainings, sort by date */
      this.covid19s = (await Contentful.getAllEntriesByContentType('covid19')).data.items
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    },
    watch: {
      '$route.query.q': {
        immediate: true,
        async handler (queryString) {
          this.filteredCovid19s = (await Contentful.getAllEntriesByContentTypeAndQuery('covid19', queryString)).data.items
        }
      }
    },
    components: {
      Covid19SearchBar,
      Covid19SummaryCard,
      Loader
    }
  }
</script>

<style scoped>
  .flex-column {
    display: flex;
  }
  .section {
    padding: 0.8rem 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ListCovid19s.vue